$(function() {
  $('.search-bar-filter-button').on('click', function () {
    $('.search-container').addClass('search-filter-active');
    POC.sidebar.collapsed = true;
  });

  $('.search-filter-clear').on('click', function (e) {
    $('.search-container').removeClass('search-filter-active');
  });
});